module.exports = __webpack_public_path__ + "static/media/about-img4.c6354488.svg";